import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getPlatformSettings, getSettings } from '../actions';

/** Loads the legacy cloud catalog/onboarding state without coupling it to the plugin wizard. */
const CloudDataWizard = ({ children }) => {
  const dispatch = useDispatch();
  const { routeShopId } = useParams();

  useEffect(() => {
    if (!routeShopId) return;
    dispatch(getSettings(routeShopId));
    dispatch(getPlatformSettings(routeShopId));
  }, [dispatch, routeShopId]);

  return <>{children}</>;
};

CloudDataWizard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CloudDataWizard;
